// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseInAppMessagesAreaRoutes = {
  route: '/in-app-messages',
}

export const InAppMessagesAreaRoutes = transformRoutes(
  BaseInAppMessagesAreaRoutes,
)
